import { CSSProperties } from 'react'
import { clsx } from 'modules/Utils'
import Colors from 'modules/Colors'
import Icon from 'elements/Icon'

interface UnavailableCampaignBannerProps {
    className?: string
    style?: CSSProperties
    campaignType: string
}

const UnavailableCampaignBanner = ({
    className,
    style,
    campaignType
}: UnavailableCampaignBannerProps) => {
    return (
        <div
            className={clsx('unavailableCampaignBanner', className)}
            style={Object.assign({}, sty.unavailableCampaignBanner, style)}
        >
            <Icon
                className="unavailableCampaignBannerIcon"
                icon="info"
                size={16}
                color={Colors.yellow}
            />
            <span className="unavailableCampaignBannerText">
                {campaignType} campaigns are unavailable for the time being, and will be back soon!
            </span>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    unavailableCampaignBanner: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        backgroundColor: Colors.yellowLight,
        borderRadius: 8,
        padding: '8px 12px',
        marginTop: 8,
        fontSize: 14,
        color: Colors.yellowLabel,
        border: `1px solid ${Colors.yellowTransparent}`,
    }
}

export default UnavailableCampaignBanner 